// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query products($filterBy: InputProductsQueryFilter)  {\nproducts(filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.products;
  let value$2 = value$1.edges;
  return {
    products: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.products;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.__typename;
    let node = {
      __typename: value$5,
      shop: shop
    };
    let value$6 = value.__typename;
    return {
      __typename: value$6,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let products = {
    __typename: value$3,
    edges: edges
  };
  return {
    products: products
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectProductKindEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a === "SPIRITUOUS" ? "SPIRITUOUS" : (
        a === "BEER" ? "BEER" : (
            a === "WINE" ? "WINE" : "SIMPLE"
          )
      )
  };
}

function serializeInputObjectProductColorEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a === "ORANGE" ? "ORANGE" : (
        a === "RED" ? "RED" : (
            a === "AMBER" ? "AMBER" : (
                a === "DARK" ? "DARK" : (
                    a === "BLACK" ? "BLACK" : (
                        a === "BLOND" ? "BLOND" : (
                            a === "ROSE" ? "ROSE" : "WHITE"
                          )
                      )
                  )
              )
          )
      )
  };
}

function serializeInputObjectInputProductsQueryFilter(inp) {
  let a = inp.name;
  let a$1 = inp.kind;
  let a$2 = inp.producer;
  let a$3 = inp.color;
  let a$4 = inp.variantCkus;
  let a$5 = inp.shopIds;
  let a$6 = inp.archived;
  return {
    name: a !== undefined ? ({
        _equals: a._equals
      }) : undefined,
    kind: a$1 !== undefined ? serializeInputObjectProductKindEqualsFilter(a$1) : undefined,
    producer: a$2 !== undefined ? ({
        _equals: a$2._equals
      }) : undefined,
    color: a$3 !== undefined ? serializeInputObjectProductColorEqualsFilter(a$3) : undefined,
    variantCkus: a$4 !== undefined ? serializeInputObjectInFilter(a$4) : undefined,
    shopIds: a$5 !== undefined ? serializeInputObjectInFilter(a$5) : undefined,
    archived: a$6 !== undefined ? (
        a$6 === "ONLY" ? "ONLY" : (
            a$6 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputProductsQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputProductsQueryFilter(name, kind, producer, color, variantCkus, shopIds, archived, param) {
  return {
    name: name,
    kind: kind,
    producer: producer,
    color: color,
    variantCkus: variantCkus,
    shopIds: shopIds,
    archived: archived
  };
}

function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectProductKindEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectProductColorEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let ProductsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductsQueryFilter: serializeInputObjectInputProductsQueryFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectProductKindEqualsFilter: serializeInputObjectProductKindEqualsFilter,
  serializeInputObjectProductColorEqualsFilter: serializeInputObjectProductColorEqualsFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductsQueryFilter: makeInputObjectInputProductsQueryFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectProductKindEqualsFilter: makeInputObjectProductKindEqualsFilter,
  makeInputObjectProductColorEqualsFilter: makeInputObjectProductColorEqualsFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let ProductsQuery_refetchQueryDescription = include.refetchQueryDescription;

let ProductsQuery_use = include.use;

let ProductsQuery_useLazy = include.useLazy;

let ProductsQuery_useLazyWithVariables = include.useLazyWithVariables;

let ProductsQuery = {
  ProductsQuery_inner: ProductsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductsQueryFilter: serializeInputObjectInputProductsQueryFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectProductKindEqualsFilter: serializeInputObjectProductKindEqualsFilter,
  serializeInputObjectProductColorEqualsFilter: serializeInputObjectProductColorEqualsFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductsQueryFilter: makeInputObjectInputProductsQueryFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectProductKindEqualsFilter: makeInputObjectProductKindEqualsFilter,
  makeInputObjectProductColorEqualsFilter: makeInputObjectProductColorEqualsFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: ProductsQuery_refetchQueryDescription,
  use: ProductsQuery_use,
  useLazy: ProductsQuery_useLazy,
  useLazyWithVariables: ProductsQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query ProductQuery($cku: CKU!, $filterBy: InputProductsByVariantCkuQueryFilter)  {\nproductsByVariantCku(cku: $cku, first: 1, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nkind  \ncolor  \nproducer  \nfamily  \ndesignation  \ncountry  \nregion  \nbeerType  \nwineType  \nwhiteWineType  \ntax  {\n__typename  \nid  \nvalue  \n}\n\ncategory  {\n__typename  \nid  \nformattedName  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.productsByVariantCku;
  let value$2 = value$1.edges;
  return {
    productsByVariantCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.kind;
        let tmp;
        switch (value$2) {
          case "BEER" :
            tmp = "BEER";
            break;
          case "SIMPLE" :
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS" :
            tmp = "SPIRITUOUS";
            break;
          case "WINE" :
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$3 = value$1.color;
        let tmp$1;
        if (value$3 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$3) {
            case "AMBER" :
              tmp$2 = "AMBER";
              break;
            case "BLACK" :
              tmp$2 = "BLACK";
              break;
            case "BLOND" :
              tmp$2 = "BLOND";
              break;
            case "DARK" :
              tmp$2 = "DARK";
              break;
            case "ORANGE" :
              tmp$2 = "ORANGE";
              break;
            case "RED" :
              tmp$2 = "RED";
              break;
            case "ROSE" :
              tmp$2 = "ROSE";
              break;
            case "WHITE" :
              tmp$2 = "WHITE";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$4 = value$1.producer;
        let value$5 = value$1.family;
        let value$6 = value$1.designation;
        let value$7 = value$1.country;
        let value$8 = value$1.region;
        let value$9 = value$1.beerType;
        let value$10 = value$1.wineType;
        let tmp$3;
        if (value$10 == null) {
          tmp$3 = undefined;
        } else {
          let tmp$4;
          switch (value$10) {
            case "EFFERVESCENT" :
              tmp$4 = "EFFERVESCENT";
              break;
            case "STILL" :
              tmp$4 = "STILL";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$3 = tmp$4;
        }
        let value$11 = value$1.whiteWineType;
        let tmp$5;
        if (value$11 == null) {
          tmp$5 = undefined;
        } else {
          let tmp$6;
          switch (value$11) {
            case "DRY" :
              tmp$6 = "DRY";
              break;
            case "SEMIDRY" :
              tmp$6 = "SEMIDRY";
              break;
            case "SOFT" :
              tmp$6 = "SOFT";
              break;
            case "SWEET" :
              tmp$6 = "SWEET";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$5 = tmp$6;
        }
        let value$12 = value$1.tax;
        let value$13 = value$1.category;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            kind: tmp,
            color: tmp$1,
            producer: !(value$4 == null) ? value$4 : undefined,
            family: !(value$5 == null) ? value$5 : undefined,
            designation: !(value$6 == null) ? value$6 : undefined,
            country: !(value$7 == null) ? value$7 : undefined,
            region: !(value$8 == null) ? value$8 : undefined,
            beerType: !(value$9 == null) ? value$9 : undefined,
            wineType: tmp$3,
            whiteWineType: tmp$5,
            tax: {
              __typename: value$12.__typename,
              id: value$12.id,
              value: value$12.value
            },
            category: !(value$13 == null) ? ({
                __typename: value$13.__typename,
                id: value$13.id,
                formattedName: value$13.formattedName
              }) : undefined
          }
        };
      })
    }
  };
}

function serialize$1(value) {
  let value$1 = value.productsByVariantCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.category;
    let category;
    if (value$2 !== undefined) {
      let value$3 = value$2.formattedName;
      let value$4 = value$2.id;
      let value$5 = value$2.__typename;
      category = {
        __typename: value$5,
        id: value$4,
        formattedName: value$3
      };
    } else {
      category = null;
    }
    let value$6 = value$1.tax;
    let value$7 = value$6.value;
    let value$8 = value$6.id;
    let value$9 = value$6.__typename;
    let tax = {
      __typename: value$9,
      id: value$8,
      value: value$7
    };
    let value$10 = value$1.whiteWineType;
    let whiteWineType = value$10 !== undefined ? (
        value$10 === "SWEET" ? "SWEET" : (
            value$10 === "SEMIDRY" ? "SEMIDRY" : (
                value$10 === "SOFT" ? "SOFT" : "DRY"
              )
          )
      ) : null;
    let value$11 = value$1.wineType;
    let wineType = value$11 !== undefined ? (
        value$11 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL"
      ) : null;
    let value$12 = value$1.beerType;
    let beerType = value$12 !== undefined ? value$12 : null;
    let value$13 = value$1.region;
    let region = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.country;
    let country = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.designation;
    let designation = value$15 !== undefined ? value$15 : null;
    let value$16 = value$1.family;
    let family = value$16 !== undefined ? value$16 : null;
    let value$17 = value$1.producer;
    let producer = value$17 !== undefined ? value$17 : null;
    let value$18 = value$1.color;
    let color = value$18 !== undefined ? (
        value$18 === "ORANGE" ? "ORANGE" : (
            value$18 === "RED" ? "RED" : (
                value$18 === "AMBER" ? "AMBER" : (
                    value$18 === "DARK" ? "DARK" : (
                        value$18 === "BLACK" ? "BLACK" : (
                            value$18 === "BLOND" ? "BLOND" : (
                                value$18 === "ROSE" ? "ROSE" : "WHITE"
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    let value$19 = value$1.kind;
    let kind = value$19 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        value$19 === "BEER" ? "BEER" : (
            value$19 === "WINE" ? "WINE" : "SIMPLE"
          )
      );
    let value$20 = value$1.name;
    let value$21 = value$1.id;
    let value$22 = value$1.__typename;
    let node = {
      __typename: value$22,
      id: value$21,
      name: value$20,
      kind: kind,
      color: color,
      producer: producer,
      family: family,
      designation: designation,
      country: country,
      region: region,
      beerType: beerType,
      wineType: wineType,
      whiteWineType: whiteWineType,
      tax: tax,
      category: category
    };
    let value$23 = value.__typename;
    return {
      __typename: value$23,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let productsByVariantCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    productsByVariantCku: productsByVariantCku
  };
}

function serializeInputObjectInFilter$1(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputProductsByVariantCkuQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$1(a) : undefined,
    archived: a$1 !== undefined ? (
        a$1 === "ONLY" ? "ONLY" : (
            a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeVariables$1(inp) {
  let a = inp.filterBy;
  return {
    cku: inp.cku,
    filterBy: a !== undefined ? serializeInputObjectInputProductsByVariantCkuQueryFilter(a) : undefined
  };
}

function makeVariables$1(cku, filterBy, param) {
  return {
    cku: cku,
    filterBy: filterBy
  };
}

function makeInputObjectInputProductsByVariantCkuQueryFilter(shopIds, archived, param) {
  return {
    shopIds: shopIds,
    archived: archived
  };
}

function makeInputObjectInFilter$1(_in, param) {
  return {
    _in: _in
  };
}

let ProductQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputProductsByVariantCkuQueryFilter: serializeInputObjectInputProductsByVariantCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  makeVariables: makeVariables$1,
  makeInputObjectInputProductsByVariantCkuQueryFilter: makeInputObjectInputProductsByVariantCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let ProductQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let ProductQuery_use = include$1.use;

let ProductQuery_useLazy = include$1.useLazy;

let ProductQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let ProductQuery = {
  ProductQuery_inner: ProductQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputProductsByVariantCkuQueryFilter: serializeInputObjectInputProductsByVariantCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  makeVariables: makeVariables$1,
  makeInputObjectInputProductsByVariantCkuQueryFilter: makeInputObjectInputProductsByVariantCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  refetchQueryDescription: ProductQuery_refetchQueryDescription,
  use: ProductQuery_use,
  useLazy: ProductQuery_useLazy,
  useLazyWithVariables: ProductQuery_useLazyWithVariables
};

export {
  ProductsQuery,
  ProductQuery,
}
/* query Not a pure module */
